import {
  RoomlayoutServiceRow,
  RoomlayoutServiceRowValues
} from "../Domain/Types/FacilityService-Roomlayout-row.types";

/**
 * takes row data and assembles a partial room layout item object
 */
export function mapUpdatedRowToPartialRoomlayoutItem(
  values: RoomlayoutServiceRowValues,
  rowOriginal: RoomlayoutServiceRow
): Partial<RoomlayoutServiceRow> {
  return {
    id: values["id"] ?? rowOriginal.id,
    name: values.name,
    description: values["description"],
    picturePaths: values.picturePaths,
    layout: values.layout
  };
}
